/** The dashboard's URL segment, used by routes. */
export const DASHBOARD_SEGMENT = "dashboard";
/** The dashboard's full path, used by navigation and links. */
export const DASHBOARD_PATH = `/${DASHBOARD_SEGMENT}`;
